"use client";
import { useEffect } from "react";

declare global {
  interface Window {
    chatwootSettings?: {
      hideMessageBubble?: boolean;
      position?: "left" | "right";
      locale?: string;
      useBrowserLanguage?: boolean;
      type?: "standard" | "expanded_bubble";
      launcherTitle?: string;
    };
    chatwootSDK?: {
      run: (options: { websiteToken: string; baseUrl: string }) => void;
    };
  }
}

export const ChatwootWidget = ({ websiteToken, baseUrl }: { websiteToken: string; baseUrl: string }) => {
  useEffect(() => {
    if (!websiteToken || !baseUrl) {
      console.warn("Chatwoot: Missing websiteToken or baseUrl");
      return;
    }

    window.chatwootSettings = {
      hideMessageBubble: false,
      position: "right",
      useBrowserLanguage: true,
      type: "expanded_bubble",
      launcherTitle: "Cần hỗ trợ ?",
    };

    const script = document.createElement("script");
    script.src = "https://cs.honganh.vn/packs/js/sdk.js";
    script.defer = true;
    script.async = true;
    script.onload = () => {
      window.chatwootSDK?.run({
        websiteToken,
        baseUrl,
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [websiteToken, baseUrl]);

  return null;
};
